import React from 'react'
import { Line, Bar } from 'react-chartjs-2'
import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import TableAA from 'src/components/reports/Tables/TableAA'
import TableIndustry from 'src/components/reports/Tables/TableIndustry'
import { useStyles } from '../styles'

const Total4WMarketProductsCard = (props) => {
  const {
    cardTitle = '',
    selectedDate,
    arrayTable1 = [],
    arrayG1 = [],
    paramG1 = '',
    arrayTable2 = [],
    paramT3 = '',
    arrayG3A = [],
    arrayG3B = [],
    paramG3 = '',
  } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>{cardTitle}</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA
              array={arrayTable1}
              selectedDate={selectedDate}
              disableAAA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>
              Evolución Total del Mercado en miles -{' '}
              {selectedDate.getFullYear()}
            </h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                arrayG1,
                'Y',
                paramG1,
                'AA',
                'Año',
                '1',
              )}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TableIndustry
              array={arrayTable2}
              selectedDate={selectedDate}
              param={paramT3}
              param1Tsum="PERIODO1"
              param2Tsum="PERIODO2"
            />
          </Grid>
          <br />
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación del mercado - años</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(
                arrayG3A,
                paramG3,
                'PORCENTAJE',
                'Y',
                '100',
              )}
              options={Utils.optionsLine}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación del mercado - mes</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(
                arrayG3B,
                paramG3,
                'PORCENTAJE',
                'MES',
                '100',
              )}
              options={Utils.optionsLine}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default Total4WMarketProductsCard
